import { TradingrobotState } from './type';

export const initialTradingrobotState: TradingrobotState = {
  edittingRobot: null,
  startingRobot: null,
  stoppingRobot: null,
};
